module.exports = __webpack_public_path__ + "img/icon_menu.aff38e20.svg";